import {
    clearActiveNotification,
    clearPendingNotification,
    notificationState,
    setActiveNotification
} from '@/stores/notificationStore';
import router from "@/router";
import {useBiometric} from "@/composables/useBiometric.ts";
import {useAuth} from '@/composables/useAuth';
import {NOTIFICATION_TYPE} from "@/utils/constants";
import {useNavigation} from "@/composables/useNavigation.ts";

export const handleNotificationRouting = async (payload: any) => {
    const { silentAuthenticate } = useBiometric();
    const { executeRefreshSession } = useAuth();

    // Pass the router instance down explicitly to dodge the context error!
    const { goTo } = useNavigation(router);

    if (!payload?.notificationId) return;

    await setActiveNotification({
        ...payload,
        _tapTimestamp: Date.now()
    });

    await router.isReady();

    let destinationPath: string | null = null;

    if (payload.type === NOTIFICATION_TYPE.QBI) {
        // TODO: remove this once the deeplink system is in place
        await clearActiveNotification();
        destinationPath = '/qbi';
    } else if (payload.type === NOTIFICATION_TYPE.PERMISSION) {
        destinationPath = '/permission';
    } else if (payload.type === NOTIFICATION_TYPE.QUICK_REAUTH) {
        return await silentAuthenticate(
            async () => {
                return await executeRefreshSession(true);
            },
            {
                onSuccess: async () => {
                    await clearActiveNotification();
                }
            }
        );
    }

    if (!destinationPath) return;

    const navState = {
        notificationId: payload.notificationId,
        ...(window.history.state?.token ? { token: window.history.state.token } : {}),
    };

    const currentRoute = router.currentRoute.value;
    const isSamePage = currentRoute.path === destinationPath;

    return await goTo(destinationPath, {
        state: navState,
        replace: isSamePage
    });
};

// call this from App.vue once initAuth and setupNotifications are done
export const processPendingNotification = async (isAuthenticated: boolean): Promise<boolean> => {
    if (!notificationState.pendingNotification) return false;
    if (!isAuthenticated) return false;

    const data = { ...notificationState.pendingNotification };
    await clearPendingNotification();
    await handleNotificationRouting(data);
    return true;
};